var cilInputPower = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M152,16V120H88V311.005l104,96v89H320V407.005l104-96V120H360V16H328V120H184V16ZM392,152V297L288,393V464H224V393L120,297V152Z' class='ci-primary'/>"];

export { cilInputPower };

